import React, { Component } from "react"
import { Icon } from "semantic-ui-react"
import "../css/Social.css"

//component
import { sizeofwindows } from "../containers/Function/App.function"
import { ContactUs } from "../containers/ConstData/constHelp"

//material ui
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import IconButton from "@material-ui/core/IconButton"
import { SocialStyle } from "../containers/Style/SocialStyle"

class Social extends Component {
	constructor(props) {
		super(props)
		this.state = {
			search: "",
			hideNav: false
		}
	}
	componentDidMount() {
		window.addEventListener("resize", this.resize.bind(this))
		this.resize()
	}
	resize() {
		this.setState({ hideNav: sizeofwindows("smd") })
	}
	render() {
		let { hideNav } = this.state
		const { classes, type } = this.props
		let fbType = "icon facebooks"
		let lnTpye = "icon linkedins"
		let twType = "icon twitters"
		let ytType = "icon youtubes"

		if (type === 2) {
			fbType = "icon facebookColor"
			lnTpye = "icon linkedinsColor"
			twType = "icon twittersColor"
			ytType = "icon youtubesColor"
		}
		return (
			<div className="div_social">
				<a
					aria-label="facebook"
					href={ContactUs.facebook}
					target="_blank"
					rel="noopener noreferrer"
					className="a_Social"
				>
					<IconButton aria-label="facebook" className={classes.margin}>
						<Icon
							name="facebook"
							className={hideNav ? "icon facebookhideNav" : fbType}
						/>
					</IconButton>
				</a>

				<a
					aria-label="linkedin"
					href={ContactUs.linkedin}
					target="_blank"
					rel="noopener noreferrer"
					className="a_Social"
				>
					<IconButton aria-label="linkedin" className={classes.margin}>
						<Icon
							name="linkedin"
							className={hideNav ? "icon linkedinhideNav" : lnTpye}
						/>
					</IconButton>
				</a>
				<a
					aria-label="twitter"
					href={ContactUs.twitter}
					target="_blank"
					rel="noopener noreferrer"
					className="a_Social"
				>
					<IconButton aria-label="twitter" className={classes.margin}>
						<Icon
							name="twitter"
							className={hideNav ? "icon twitterhideNav" : twType}
						/>
					</IconButton>
				</a>
				<a
					aria-label="youtube"
					href={ContactUs.youtube}
					target="_blank"
					rel="noopener noreferrer"
					className="a_Social"
				>
					<IconButton aria-label="youtube" className={classes.margin}>
						<Icon
							name="youtube"
							className={hideNav ? "icon youtubehideNav" : ytType}
						/>
					</IconButton>
				</a>
			</div>
		)
	}
}
Social.propTypes = {
	classes: PropTypes.object.isRequired
}
export default withStyles(SocialStyle)(Social)
